// extracted by mini-css-extract-plugin
export default {"ColumnsContainer":"ColumnsContainer_ColumnsContainer__tOQnF"};